import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const DoorExitIllustration = ({ width = 40, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#ED585D"
          d="M21.087 21.11h14.84l-2.092 2.166c-.417.433-.405 1.12.026 1.538.433.416 1.122.404 1.539-.027l4.6-4.764-4.6-4.765c-.213-.221-.499-.333-.783-.333-.272 0-.544.101-.756.305-.431.418-.443 1.107-.026 1.538l2.092 2.166h-14.84c-.601 0-1.087.488-1.087 1.088 0 .6.486 1.088 1.087 1.088"
        />
        <path
          stroke="#955D3F"
          strokeWidth="1.5"
          d="M24.985 16.923L24.985 3.299 9.6 3.299 9.6 37.059 24.985 37.059 24.985 23.15"
        />
        <path
          fill="#955D3F"
          d="M.798 3.87L12.99.053c.732-.23 1.474.32 1.474 1.09v37.713c0 .773-.745 1.323-1.478 1.09L.794 36.076C.32 35.925 0 35.483 0 34.985V4.96c0-.5.323-.943.798-1.09"
        />
        <path
          fill="#F6F6F6"
          d="M10.823 20.03c0 .687.48 1.242 1.072 1.242.592 0 1.072-.555 1.072-1.242 0-.687-.48-1.243-1.072-1.243-.592 0-1.072.556-1.072 1.243"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M12.99.053L6.97 1.938v36.098l6.016 1.91c.733.233 1.478-.317 1.478-1.09V1.145c0-.771-.743-1.32-1.474-1.091"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
